import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { EnvService } from '@src/app/modules/env';

import { ImageType } from '../../types';

@Component({
  selector: 'preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewComponent {
  private readonly env = inject(EnvService);

  @Input() index = 0;
  @Input() title?: string;
  @Input() images: ImageType[] = [];

  @Output() close = new EventEmitter<void>();

  protected download(index: number) {
    const { src, fileName } = this.images[index];

    this.env.downloadFile({
      src,
      fileName,
    });
  }
}
